"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.FrameVB = void 0;
const ObjectUtils_1 = require("../../utils/ObjectUtils");
const validationBundler_1 = require("./validationBundler");
class FrameVB extends validationBundler_1.ValidationBundler {
    constructor(parentTag) {
        super(parentTag, 'frame');
        this.frameIsValidMsg = 'frame value is not valid';
    }
    getValidations(frame) {
        let validations = [];
        validations = [...validations, ...this.getMyValidations(frame)];
        return validations;
    }
    getMyValidations(frame) {
        return [
            //(ps: PresentationSubmission) =>
            //           PresentationSubmissionVB.descriptorMapMustBePresent(ps?.descriptor_map),
            //(f as Frame) => FrameVB.
            {
                tag: this.getMyTag(),
                target: frame,
                predicate: FrameVB.frameIsValid,
                message: this.frameIsValidMsg,
            },
        ];
    }
    getMyTag() {
        return this.parentTag + '.' + this.myTag;
    }
    /**
     * this is based on https://github.com/digitalbazaar/jsonld.js/blob/main/lib/frame.js
     * @param frame
     */
    static frameIsValid(frame) {
        if (!frame || Array.isArray(frame) || !(typeof frame === 'object')) {
            return false;
        }
        const fr = frame;
        if (fr && fr['@id']) {
            for (const id of ObjectUtils_1.ObjectUtils.asArray(frame['@id'])) {
                // @id must be wildcard or an IRI
                if (!(ObjectUtils_1.ObjectUtils.isObject(id) || ObjectUtils_1.ObjectUtils.isUrlAbsolute(id)) ||
                    (ObjectUtils_1.ObjectUtils.isString(id) && id.indexOf('_:') === 0)) {
                    return false;
                }
            }
        }
        //
        if (fr['@types']) {
            for (const type of ObjectUtils_1.ObjectUtils.asArray(frame['@types'])) {
                // @id must be wildcard or an IRI
                if (!(ObjectUtils_1.ObjectUtils.isObject(type) || ObjectUtils_1.ObjectUtils.isUrlAbsolute(type)) ||
                    (ObjectUtils_1.ObjectUtils.isString(type) && type.indexOf('_:') === 0)) {
                    return false;
                }
            }
        }
        return true;
    }
}
exports.FrameVB = FrameVB;
